
import { Vue } from "vue-class-component";

class Props {}
export default class Delete extends Vue.with(Props) {}
